import React, { useEffect, useState, useContext } from "react";
import Container from "src/layout/Container";
import {
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import axios from "axios";
import { FormInformation, UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import { CancelOutlined, SaveAlt } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  inputComponent: {
    height: "30px",
    width: "350px",
  },

  inputComponentLeft: {
    height: "30px",
    width: "450px",
  },

  inputComponentCenter: {
    height: "30px",
    width: "250px",
  },

  inputComponentRight: {
    height: "30px",
    width: "250px",
  },
}));

const PrintLayout = () => {
  const { users } = useContext(UsersData);
  const { formInfo, renderFormInfo } = useContext(FormInformation);
  const [data, setData] = useState({});
  const classes = useStyles();
  // const [allLocalRad, setAllLocalRad] = React.useState({
  //   data: [],
  //   ready: false,
  // });

  // const getAllLocalRadiologist = () => {
  //   var params = { user_id: users.user_id, management_id: users.management_id };
  //   axios
  //     .get("imaging/get-all-localrad-list", { params })
  //     .then((response) => {
  //       const data = response.data;
  //       setAllLocalRad({ data: data, ready: true });
  //     })
  //     .catch((error) => {
  //       Notify.requestError(error);
  //     });
  // };

  const handleFromEdit = async (e) => {
    e.preventDefault();
    e.persist();

    var formdata = new FormData(e.target);
    formdata.set("management_id", users.management_id);
    formdata.set("main_mgmt_id", users.main_mgmt_id);

    let response = await axios.post(
      "imaging/edit/result-print-layout",
      formdata
    );

    if (response.data === "success") {
      e.target.reset();
      renderFormInfo();
      Notify.successRequest("edit print layout");
    }
  };

  const onInputchange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const renderB = React.useCallback(() => {
    setTimeout(() => {
      setData(formInfo);
    }, 2000);
  }, [formInfo]);

  useEffect(() => {
    renderB();
    // getAllLocalRadiologist();

    // eslint-disable-next-line
  }, [renderB]);
  return (
    <>
      <Container
        breadcrumbs={{
          enable: true,
          current: "print layout",
          items: [{ name: "Dashboard", path: "/sph/app" }],
        }}
        title="Print Layout"
      >
        <Box m={2} border={1} borderColor="#AEAEAE">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <form onSubmit={handleFromEdit} noValidate>
                <Box m={3}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height={100}
                  >
                    <Box flexGrow={1} width={"100%"}>
                      <Box hidden>
                        <TextField
                          required
                          name="ifh_id"
                          value={
                            data.ifh_id !== null || data.ifh_id !== undefined
                              ? data.ifh_id
                              : ""
                          }
                          inputProps={{
                            style: { textAlign: "center" },
                          }}
                          onChange={onInputchange}
                        />
                      </Box>
                      <Box align="center">
                        <Box>
                          <TextField
                            required
                            name="name"
                            value={data.name}
                            inputProps={{
                              style: { textAlign: "center" },
                            }}
                            className={classes.inputComponent}
                            onChange={onInputchange}
                          />
                        </Box>
                        <Box maxWidth={500} />
                      </Box>

                      <Box align="center">
                        <Box>
                          <TextField
                            required
                            name="address"
                            value={data.address}
                            inputProps={{
                              style: { textAlign: "center" },
                            }}
                            className={classes.inputComponent}
                            onChange={onInputchange}
                          />
                        </Box>
                        <Box maxWidth={500} />
                      </Box>

                      <Box align="center">
                        <Box>
                          <TextField
                            required
                            name="contact_number"
                            value={data.contact_number}
                            inputProps={{
                              style: { textAlign: "center" },
                            }}
                            className={classes.inputComponent}
                            onChange={onInputchange}
                          />
                        </Box>
                        <Box maxWidth={600} />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box m={3}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height={100}
                    borderColor={"#AEAEAE"}
                    borderRadius={4}
                    border={1}
                  >
                    <Typography variant="h3"> CONTENT </Typography>
                  </Box>

                  {/* <Box my={2} mt={5}>
                    <Box display="flex">
                      <Box flexGrow={1} />
                      <Box>
                        <Box>
                          <TextField
                            required
                            name="radiologist"
                            value={data.radiologist}
                            select
                            SelectProps={{
                              native: true,
                            }}
                            inputProps={{
                              style: { textAlign: "center" },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            className={classes.inputComponent}
                            onChange={onInputchange}
                          >
                            <option value={""}>Select</option>
                            {allLocalRad.data.length > 0 ? (
                              allLocalRad.data.map((data1, index1) => {
                                return (
                                  <option key={index1} value={data1.label}>
                                    {data1.label}
                                  </option>
                                );
                              })
                            ) : (
                              <option value={""}>No result</option>
                            )}
                          </TextField>
                        </Box>
                        <Box maxWidth={250} />
                        <Typography style={{ marginLeft: 125 }}>
                          Radiologist
                        </Typography>
                        <Box>
                          <Box>
                            <TextField
                              required
                              name="radiologist_lcn"
                              value={data.radiologist_lcn}
                              inputProps={{
                                style: { textAlign: "center" },
                              }}
                              className={classes.inputComponent}
                              onChange={onInputchange}
                            />
                          </Box>
                          <Box maxWidth={250} />
                        </Box>
                      </Box>
                    </Box>
                  </Box> */}

                  <Box display="flex" mt={5}>
                    <Box flexGrow={1} />
                    <Box mr={2}>
                      <Button
                        className={"d-print-none"}
                        variant="contained"
                        color="default"
                        startIcon={<CancelOutlined />}
                        // onClick={() => close()}
                      >
                        Close
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        className={"d-print-none"}
                        variant="contained"
                        color="primary"
                        startIcon={<SaveAlt />}
                        type="submit"
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default PrintLayout;
